import { publisherManager } from '@highereducation/publishers';

const getPublisherConfig = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  let { host } = window.location;

  // If we are in wp preview enviorment try to get the host from the window object
  if (window.location.hostname.includes('wpengine')) {
    if (window.HE.publisher) {
      host = window.HE.publisher.name;
    }
  }

  const config = publisherManager.getPublisherThemeFromListByHost(host);

  return config;
};

export default getPublisherConfig;
